/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPrompt2.vue?vue&type=template&id=e14e6c78&scoped=true"
import script from "./popPrompt2.vue?vue&type=script&lang=js"
export * from "./popPrompt2.vue?vue&type=script&lang=js"
import style0 from "./popPrompt2.vue?vue&type=style&index=0&id=e14e6c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14e6c78",
  null
  
)

export default component.exports